<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const { headlineText, headlineType, toplineText, toplineType, mainText, Rows } =
  props.content.data;

</script>
<template>
  <section class="">
    <div class="container xl:px-5">
      <div class="mb-10 lg:mb-[3.75rem]">
        <SharedTopline
          :headline="toplineText"
          :headlineType="toplineType"
        ></SharedTopline>
        <SharedHeadline
          :headline="headlineText"
          :headlineType="headlineType"
        ></SharedHeadline>

        <div class="mb-4 mt-8">
        <p v-html="mainText"></p>
        </div>
      </div>
      <div
        class="flex justify-between prose-img:w-[5.25rem] sm:prose-img:w-[9rem] mb-[3.75rem] gap-2"
      >
        <div>
          <img class="mr-2" src="assets/images/sp1.png" alt="sp1" />
        </div>
        <div>
          <img class="mr-2" src="assets/images/sp2.png" alt="sp2" />
        </div>
        <div>
          <img class="mr-2" src="assets/images/sp3.png" alt="sp3" />
        </div>
        <div>
          <img class="mr-2" src="assets/images/sp4.png" alt="sp4" />
        </div>
        <div>
          <img class="mr-2" src="assets/images/sp6.png" alt="sp6" />
        </div>
      </div>

      <template v-for="(row, index) in Rows" :key="index">
        <div class="py-[1.875rem] border-b border-skin-primary">
          <div class="flex flex-wrap items-center gap-y-5">
            <div class="w-full laptop:w-2/5">
              <div class="flex items-center gap-5">
                <div class="w-[5.625rem]">
                  <NuxtImg
                    format="webp"
                    laoding="lazy"
                    v-if="row.rowImage && row.rowImage.media"
                    :src="row.rowImage.media.url"
                    alt=""
                  />
                </div>
                <h4 class="font-base">{{ row.rowTitle }}</h4>
              </div>
            </div>
            <div class="w-full laptop:w-3/5">
              <div
                class="flex justify-start prose-img:max-w-full md:prose-img:max-w-[5.25rem] gap-2"
              >
                <div class="w-1/5" v-if="row.rowSP1 == 1">
                  <img class="mr-2" src="assets/images/sp1.png" alt="sp1" />
                </div>
                <div class="w-1/5" v-if="row.rowSP2 == 1">
                  <img class="mr-2" src="assets/images/sp2.png" alt="sp2" />
                </div>
                <div class="w-1/5" v-if="row.rowSP3 == 1">
                  <img class="mr-2" src="assets/images/sp3.png" alt="sp3" />
                </div>
                <div class="w-1/5" v-if="row.rowSP4 == 1">
                  <img class="mr-2" src="assets/images/sp4.png" alt="sp4" />
                </div>
                <div class="w-1/5" v-if="row.rowSP6 == 1">
                  <img class="mr-2" src="assets/images/sp6.png" alt="sp6" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>
